import { motion } from 'framer-motion'
import { Ban, Check } from 'lucide-react'

type BeforeAfterType = {
    Previous: string[]
    After: string[]
}
export default function BeforeAfter(props: BeforeAfterType) {
    return (
        <section className="border-t border-base-300/70 w-full pt-24 pb-24" >
            <div className="max-w-page mx-auto px-4 md:px-8 xl:px-0  grid grid-cols-1 md:grid-cols-2 gap-16">
                <div>
                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: 0.2 }}>
                        <div className="flex flex-row gap-3 items-center pb-4">
                            <Ban className="w-8 h-8 text-red-900 opacity-90" />
                            <h5 className="text-3xl tracking-wide font-semibold font-headline">Vorher</h5>
                        </div>
                    </motion.div>
                    <div className="flex flex-row gap-3 flex-wrap">
                        {props?.Previous?.map((item: any, index: number) => (
                            <motion.div
                                initial={{ opacity: 0, y: -50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}>
                                <div className="py-2 px-4 border border-base-300 rounded-lg text-sm text-accent/50">{item.Item}</div>
                            </motion.div>
                        ))}
                    </div>
                </div>
                <div>
                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: 0.2 }}>
                        <div className="flex flex-row gap-3 items-center pb-4">
                            <Check className="w-8 h-8 text-green-500 opacity-90" />
                            <h5 className="text-3xl tracking-wide font-semibold font-headline">Nachher</h5>
                        </div>
                    </motion.div>
                    <div className="flex flex-row gap-3 flex-wrap">
                        {props?.After?.map((item: any, index: number) => (
                            <motion.div
                                initial={{ opacity: 0, y: -50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}>
                                <div className="py-2 px-4 border border-accent text-sm rounded-lg">{item.Item}</div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>

        </section>
    )
}
